import './index.css';
import { Link } from 'react-router-dom';

const CustomerProposals = () => {
  return (
    <section className="customer-proposals-page">
      <div className="customer-proposals-header">
        <p>Member proposals</p>
        <h1>Your Hogcloud proposals.</h1>
        <span>Secure project proposals and documents will appear here when available.</span>
      </div>

      <div className="customer-proposals-empty">
        <h2>No proposals yet.</h2>
        <p>
          When Hogcloud prepares a proposal for your account, it will be listed here
          with secure document access.  <br></br><br></br>A proposal is for a project relating to a service and provides an estimate and Statement Of Work.
          If you are interested in a service from Hogcloud, send us a message.
        </p>
        <Link to="/contact" className="about-button">
          Contact Us
        </Link>
      </div>
    </section>
  );
};

export default CustomerProposals;
